import { render, staticRenderFns } from "./UserBirthdayListItem.vue?vue&type=template&id=2f8dd946&"
import script from "./UserBirthdayListItem.vue?vue&type=script&lang=js&"
export * from "./UserBirthdayListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports